(function () {
  'use strict';

  function addBusinessDays(startDate, businessDays) {
    var date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 12);
    var remaining = businessDays;
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) remaining -= 1;
    }
    return date;
  }

  function syncLocalizedArrivalDate(root) {
    var arrival = root.querySelector('[data-gf-arrival-date]');
    if (!arrival) return;
    if (root.dataset.gfShowArrivalDate !== 'true') {
      arrival.hidden = true;
      arrival.textContent = '';
      return;
    }

    arrival.hidden = false;
    var locale = root.dataset.gfLocale || document.documentElement.lang || 'en-US';
    if (String(locale).toLowerCase().slice(0, 2) !== 'es') return;
    var configuredDays = Number(root.dataset.gfDeliveryBusinessDays);
    var businessDays = Number.isFinite(configuredDays) && configuredDays >= 0
      ? Math.round(configuredDays)
      : 3;
    var date = addBusinessDays(new Date(), businessDays);
    try {
      arrival.textContent = new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'long'
      }).format(date);
    } catch (error) {
      arrival.textContent = new Intl.DateTimeFormat('es-MX', {
        day: 'numeric',
        month: 'long'
      }).format(date);
    }
  }

  function init(root) {
    if (!root || root.dataset.gfRbInit) return;
    root.dataset.gfRbInit = '1';
    document.body.classList.add('template-product-gutful-rosabella');
    syncLocalizedArrivalDate(root);

    var modeButtons = root.querySelectorAll('[data-gf-mode-toggle]');
    function syncModeButtons() {
      var mode = root.getAttribute('data-gf-mode') === 'onetime' ? 'onetime' : 'subscription';
      modeButtons.forEach(function (button) {
        var active = button.dataset.gfModeToggle === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
    syncModeButtons();

    var modeObserver = new MutationObserver(syncModeButtons);
    modeObserver.observe(root, { attributes: true, attributeFilter: ['data-gf-mode'] });
    root.__gfRbModeObserver = modeObserver;

    var faqHub = root.querySelector('[data-gf-faq-hub]');
    if (faqHub) {
      var faqFilters = Array.prototype.slice.call(faqHub.querySelectorAll('[data-gf-faq-filter]'));
      var faqCards = Array.prototype.slice.call(faqHub.querySelectorAll('[data-gf-faq-card]'));

      function filterFaq(category) {
        faqFilters.forEach(function (button) {
          var active = button.dataset.gfFaqFilter === category;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        faqCards.forEach(function (card) {
          card.hidden = category !== 'all' && card.dataset.gfFaqCategory !== category;
        });
      }

      faqFilters.forEach(function (button) {
        button.addEventListener('click', function () {
          filterFaq(button.dataset.gfFaqFilter || 'all');
        });
      });
      filterFaq('all');
    }

    var demoReviews = root.querySelector('[data-gf-demo-reviews]');
    if (demoReviews) {
      var demoReviewRows = Array.prototype.slice.call(demoReviews.querySelectorAll('[data-gf-demo-review]'));
      var demoReviewButtons = Array.prototype.slice.call(demoReviews.querySelectorAll('[data-gf-demo-review-page]'));
      var demoReviewStatus = demoReviews.querySelector('[data-gf-demo-review-status]');
      var demoReviewPageSize = parseInt(demoReviews.dataset.pageSize, 10) || 10;
      var demoReviewPageCount = Math.max(1, Math.ceil(demoReviewRows.length / demoReviewPageSize));
      var demoReviewPage = 0;

      function renderDemoReviewPage() {
        var first = demoReviewPage * demoReviewPageSize;
        var last = first + demoReviewPageSize;
        demoReviewRows.forEach(function (row, index) {
          row.hidden = index < first || index >= last;
        });
        demoReviewButtons.forEach(function (button) {
          var direction = Number(button.dataset.gfDemoReviewPage) || 0;
          button.disabled =
            (direction < 0 && demoReviewPage === 0) ||
            (direction > 0 && demoReviewPage === demoReviewPageCount - 1);
        });
        if (demoReviewStatus) {
          demoReviewStatus.textContent =
            (demoReviews.dataset.pageLabel || 'Page') +
            ' ' +
            (demoReviewPage + 1) +
            ' ' +
            (demoReviews.dataset.ofLabel || 'of') +
            ' ' +
            demoReviewPageCount;
        }
      }

      demoReviewButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var direction = Number(button.dataset.gfDemoReviewPage) || 0;
          demoReviewPage = Math.max(0, Math.min(demoReviewPageCount - 1, demoReviewPage + direction));
          renderDemoReviewPage();
          var firstVisibleReview = demoReviewRows[demoReviewPage * demoReviewPageSize];
          if (firstVisibleReview) firstVisibleReview.setAttribute('tabindex', '-1');
        });
      });
      renderDemoReviewPage();
    }

    var storyTrack = root.querySelector('[data-gf-rb-story-track]');
    if (storyTrack) {
      root.querySelectorAll('[data-gf-rb-scroll]').forEach(function (button) {
        button.addEventListener('click', function () {
          var direction = Number(button.dataset.gfRbScroll) || 1;
          var card = storyTrack.querySelector('.gf-rb__story-card');
          var gap = parseFloat(getComputedStyle(storyTrack).columnGap || getComputedStyle(storyTrack).gap) || 16;
          var distance = card ? card.getBoundingClientRect().width + gap : storyTrack.clientWidth * 0.82;
          storyTrack.scrollBy({
            left: distance * direction,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        });
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.gf-rb').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.gf-rb').forEach(function (root) {
      if (root.__gfRbModeObserver) root.__gfRbModeObserver.disconnect();
    });
    window.setTimeout(function () {
      if (!document.querySelector('.gf-rb')) {
        document.body.classList.remove('template-product-gutful-rosabella');
      }
    }, 0);
  });
})();
